import React, { useCallback, useMemo } from 'react'

import { ModalBase } from '@components/atoms'
import { useIsMobile, useModalCookieController } from '@hooks'
import type { PopupData } from '@models/dashboard.model'
import { dashboardAPI } from '@services/DashboardAPI'
import { useTrackPopupClickMutation } from '@services/PopupsAPI'

import { ModalStyles } from './styles'

const { popupContainer, popupImage } = ModalStyles

export default function ModalCampaign() {
	const mobile = useIsMobile()
	const [trackPopupClick] = useTrackPopupClickMutation()

	const { data: popupApiData = [] } = dashboardAPI.useGetPopupsQuery()

	const { modalsOpenStatus, forceCloseModal } = useModalCookieController({
		popups: popupApiData,
	})

	const popupToDisplay = useMemo(() => {
		const activePopups = popupApiData.filter(
			(popup) => modalsOpenStatus[popup.id]
		)

		return activePopups.length > 0 ? activePopups[0] : null
	}, [popupApiData, modalsOpenStatus])

	const handleClose = useCallback(() => {
		if (popupToDisplay) {
			forceCloseModal(popupToDisplay.id)
		}
	}, [forceCloseModal, popupToDisplay])

	const handlePopupClick = async () => {
		try {
			if (popupToDisplay) {
				await trackPopupClick({ popupId: popupToDisplay.id }).unwrap()
				window.open(popupToDisplay.link, '_blank')
			}
		} catch (error) {
			//
		}
	}

	const getImageSource = useCallback(
		(popUpData: PopupData): string => {
			return mobile ? popUpData.mobilePicture : popUpData.desktopPicture
		},
		[mobile]
	)

	return (
		<>
			{popupToDisplay && (
				<ModalBase
					title=''
					open={!!popupToDisplay}
					onOpenChange={(e) => {
						if (!e) {
							handleClose()
						}
					}}
					maxWidth='none'
					popup
				>
					<div className={popupContainer()} onClick={handlePopupClick}>
						<img
							src={getImageSource(popupToDisplay)}
							alt='Popup'
							className={popupImage()}
						/>
					</div>
				</ModalBase>
			)}
		</>
	)
}
